import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';

import { TranslationService } from '../../shared/services/translation.service';
import { UserService } from '../../shared/services/user.service';
import { BocClient, LogisticsConstraints, MillOfferNeed4Steel, ProductDetails, RequestOrder }
	from '../models/need4steel';
import { ErrorService } from '../../shared/services/error.service';

import { ProductService } from './product.api.service';

const MILL_OFFER_ID = 'millOfferID';
@Injectable({ providedIn: 'root' })
export class MillOfferService {
	millOffer?: MillOfferNeed4Steel;
	productFormGroup?: FormGroup;
	simulationResponseList: Map<string, ProductDetails>[] = [];
	filteredSoldtoShiptoList?: BocClient[];
	bocs?: Map<string, BocClient>;
	requestOrderObj!: RequestOrder;
	payer?: string;
	totalOrderAmount?: number;
	offerListErrMsgObs: Observable<string>;
	noWeightOption!: boolean;
	maxSpecCoilWeightOptionAvailable!: boolean;
	boc!: BocClient;
	logisticalRoutes: LogisticsConstraints[] = [];
	private readonly offerListErrMsgSubject = new BehaviorSubject(<string> '');
	private productFieldNamesLoaded = false;

	constructor(
		private readonly userService: UserService,
		private readonly translationService: TranslationService,
		private readonly errorService: ErrorService,
		private readonly productService: ProductService,
		private readonly snackBar: MatSnackBar
	) {
		this.offerListErrMsgObs = this.offerListErrMsgSubject.asObservable();
	}

	showError(msg?: string) {
		this.snackBar.open(
			msg === undefined
				? this.translationService.getTR('quapp.error')
				: `${ this.translationService.getTR('quapp.error') } - ${ msg }`,
			undefined,
			{ duration: 5000 }
		);
	}

	getBocs() {
		return this.userService.getSoldToRelationshipGroupsTransac('ND4ST', true, true);
	}

	resetMillOfferDetails() {
		delete this.millOffer;
		delete this.productFormGroup;
		delete this.filteredSoldtoShiptoList;
		this.simulationResponseList.length = 0;
		this.errorService.resetErrorMsg();
		this.removeMillOfferId();
	}

	getMillOfferId() {
		return localStorage.getItem(MILL_OFFER_ID);
	}

	saveMillOfferId(id: string) {
		localStorage.setItem(MILL_OFFER_ID, id);
	}

	removeMillOfferId() {
		localStorage.removeItem(MILL_OFFER_ID);
	}

	setOfferListErrorMsg(errMsg: string) {
		this.offerListErrMsgSubject.next(String(errMsg));
	}

	resetProductFieldNamesLoaded() {
		this.productFieldNamesLoaded = false;
	}

	loadProductFieldNames() {
		if (this.productFieldNamesLoaded) {
			return of(false);
		}
		return this.productService.loadFieldNameTranslations(true).pipe(tap(
			() => {
				this.productFieldNamesLoaded = true;
			}
		));
	}
}
